import React from 'react';
import DataViewerFieldBase, { DataViewerFieldBaseProps } from './DataViewerFieldBase';

export interface DataViewerCustomFieldProps<V = any> extends DataViewerFieldBaseProps {
    render: (data: V) => React.ReactNode;
}

export default class DataViewerCustomField<V = any> extends DataViewerFieldBase<DataViewerCustomFieldProps<V>> {}
